var _ellipse, _ellipse2, _path, _ellipse3, _ellipse4, _path2, _ellipse5, _path3, _ellipse6, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSounds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 127,
    viewBox: "0 0 114 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.04744,
    ry: 7.5593,
    transform: "matrix(-0.998772 -0.0495451 -0.0495451 0.998772 100.098 58.559)",
    fill: "#6DA3A3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.55139,
    ry: 7.5593,
    transform: "matrix(-0.998772 -0.0495451 -0.0495451 0.998772 69.4415 45.9393)",
    fill: "#6DA3A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.2672 48.759L67.015 13.5256L98.3505 22.6486L96.5029 59.8953M96.5528 58.8887C96.3598 62.7804 98.7948 66.0639 101.992 66.2225C105.188 66.3811 107.936 63.3547 108.13 59.4629C108.323 55.5712 105.888 52.2877 102.691 52.1291C99.4939 51.9705 96.7459 54.9969 96.5528 58.8887ZM65.2797 48.5073C65.0935 52.2601 67.5342 55.4309 70.731 55.5894C73.9278 55.748 76.6702 52.8344 76.8564 49.0816C77.0426 45.3288 74.6019 42.158 71.4051 41.9994C68.2083 41.8408 65.4659 44.7545 65.2797 48.5073Z",
    stroke: "black",
    strokeWidth: 1.92061
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7557,
    ry: 4.69463,
    transform: "matrix(-0.946681 0.322171 0.322171 0.946681 36.9512 80.8086)",
    fill: "#E0B598"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.06868,
    ry: 4.69463,
    transform: "matrix(-0.946681 0.322171 0.322171 0.946681 16.3648 80.5393)",
    fill: "#E0B598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5989 83.1255L7.54073 62.3854L27.7193 60.4773L35.1809 82.4026M34.9792 81.81C35.7588 84.1009 37.9163 85.4389 39.7982 84.7985C41.68 84.1581 42.5735 81.7818 41.7938 79.4909C41.0142 77.2 38.8567 75.862 36.9749 76.5024C35.0931 77.1428 34.1996 79.5191 34.9792 81.81ZM14.5485 82.9774C15.3003 85.1865 17.4353 86.4581 19.3171 85.8177C21.1989 85.1773 22.1149 82.8673 21.3631 80.6583C20.6114 78.4492 18.4764 77.1775 16.5946 77.8179C14.7128 78.4583 13.7967 80.7683 14.5485 82.9774Z",
    stroke: "black",
    strokeWidth: 1.92061
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.9814,
    cy: 114.697,
    rx: 5.95318,
    ry: 6.86905,
    transform: "rotate(3.02012 68.9814 114.697)",
    fill: "#87D5CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1972 79.7006L73.2697 82.9785L72.829 91.3311M71.4843 116.819L72.829 91.3311M72.829 91.3311L84.1028 89.7356M71.5325 115.904C71.346 119.44 68.8402 122.182 65.9358 122.029C63.0313 121.876 60.8281 118.885 61.0146 115.349C61.2012 111.813 63.7069 109.071 66.6114 109.224C69.5158 109.378 71.7191 112.368 71.5325 115.904Z",
    stroke: "black",
    strokeWidth: 1.92061
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.85747,
    ry: 4.45093,
    transform: "matrix(-0.998611 0.0526865 0.0526865 0.998611 24.358 25.2027)",
    fill: "#6DA3A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5577 2.52581L21.5823 4.64979L21.8678 10.062M22.7392 26.5772L21.8678 10.062M21.8678 10.062L14.5627 9.02819M22.7079 25.9846C22.8288 28.2757 24.4524 30.0525 26.3344 29.9532C28.2164 29.8539 29.644 27.9161 29.5232 25.625C29.4023 23.3339 27.7786 21.5571 25.8967 21.6563C24.0147 21.7556 22.587 23.6934 22.7079 25.9846Z",
    stroke: "black",
    strokeWidth: 1.92061
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSounds);
export default __webpack_public_path__ + "static/media/sounds.f657d8c12a8a260dd199a3497e3d6b81.svg";
export { ForwardRef as ReactComponent };